export default "__VITE_ASSET__D9blA_2R__"